import React from "react";
import { ReactSVG } from "react-svg";
import { EMPTY_STRING } from "../../../constants";

const CustomSvg = ({
  src,
  color = "currentColor",
  className = EMPTY_STRING,
  onClick = () => {},
}) => {
  return (
    <ReactSVG
      className={className}
      src={src}
      onClick={onClick}
      beforeInjection={(svg) => {
        // Get all elements that could have color attributes
        const elements = svg.querySelectorAll("*");

        elements.forEach((element) => {
          // Override fill and stroke attributes for all elements
          if (element.hasAttribute("fill")) {
            element.setAttribute("fill", color);
          }
          if (element.hasAttribute("stroke")) {
            element.setAttribute("stroke", color);
          }

          // Handle gradients by changing 'stop-color' for <stop> elements in gradients
          if (element.tagName === "stop") {
            element.setAttribute("stop-color", color);
          }
        });
      }}
    />
  );
};

export default CustomSvg;
